export const Marquee = () => {
  const items = ["Tap", "Review", "Done"];
  const row = [...Array(6)].flatMap(() => items);
  return (
    <div className="bg-ink py-5 overflow-hidden" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((word, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`font-display font-black text-2xl sm:text-3xl tracking-tight mx-6 ${i % 3 === 2 ? "text-outline-white" : "text-white"}`}>
                  {word}
                </span>
                <span className="w-2 h-2 rounded-full bg-volt mx-2" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
